import { env } from 'env-utils';

export const CUSTOM_SCOPES = `${env().REACT_APP_AUTH0_AUDIENCE}/scopes`;

export enum ScopeOptions {
  EntireOrganization = 'EntireOrganization',
  UserOnly = 'UserOnly',
  CustomScope = 'CustomScope',
}

export const SCOPE_SELECTION_OPTIONS = {
  [ScopeOptions.EntireOrganization]: {
    value: ScopeOptions.EntireOrganization,
    label: 'Entire Organization',
  },
  [ScopeOptions.UserOnly]: {
    value: ScopeOptions.UserOnly,
    label: 'User Only - based on Applications owners',
    tooltip:
      'The user can access only those applications (and related issues) for which they are the owner.',
  },
  [ScopeOptions.CustomScope]: {
    value: ScopeOptions.CustomScope,
    label: 'Custom Scope',
    helperText: 'Select Application Owners',
  },
};
